import { useQuery } from "@tanstack/react-query";
import apiService from "../backend/api";
import { getBaseUrl } from "../config/apiConfig";

const usePlans = () => {
  return useQuery({
    queryKey: ["plans"],
    queryFn: async () => {
      const data = await apiService.request(`${getBaseUrl()}/api/payment/plans`);
      return data;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};

export default usePlans;
